// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bt-1{border-top:1px solid #666}.el-badge__content{pointer-events:none}.up[x-placement^=bottom]{margin-top:5px!important}", ""]);
// Exports
module.exports = exports;
